var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 2C5.582 2 2 5.582 2 10C2 14.418 5.582 18 10 18C14.418 18 18 14.418 18 10C18 5.582 14.418 2 10 2ZM10 3C11.018 3 11.985 3.217 12.858 3.608L11.295 5.17C10.882 5.06 10.448 5 10 5C7.239 5 5 7.239 5 10C5 11.38 5.56 12.63 6.464 13.536L5.05 14.95L4.894 14.789C3.72 13.537 3 11.852 3 10C3 6.134 6.134 3 10 3ZM16.392 7.143C16.782 8.015 17 8.983 17 10C17 11.933 16.216 13.683 14.95 14.95L13.536 13.536C14.44 12.63 15 11.38 15 10C15 9.552 14.941 9.118 14.83 8.705L16.392 7.143ZM14.242 4.343L15.657 5.757L11.933 9.483C11.977 9.648 12 9.821 12 10C12 11.105 11.105 12 10 12C8.895 12 8 11.105 8 10C8 8.895 8.895 8 10 8C10.179 8 10.352 8.023 10.517 8.067L14.243 4.343H14.242Z",
    fill: "#2E3135"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.ec102409c7d06aa342f80fbf2d078e46.svg";
export { ForwardRef as ReactComponent };